import React from "react";
const SoundCloudIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "currentColor",
    ...props
  },
  /* @__PURE__ */ React.createElement("path", { d: "M5.2,9 L5.8,9 C5.9104569,9 6,9.05969537 6,9.13333333 L6,14.8666667 C6,14.9403046 5.9104569,15 5.8,15 L5.2,15 C5.0895431,15 5,14.9403046 5,14.8666667 L5,9.13333333 C5,9.05969537 5.0895431,9 5.2,9 Z M3.2,8 L3.8,8 C3.9104569,8 4,8.06268014 4,8.14 L4,14.86 C4,14.9373198 3.9104569,15 3.8,15 L3.2,15 C3.0895431,15 3,14.9373198 3,14.86 L3,8.14 C3,8.06268014 3.0895431,8 3.2,8 Z M1.2,10 L1.8,10 C1.91045695,10 2,10.0447715 2,10.1 L2,13.9 C2,13.9552284 1.91045695,14 1.8,14 L1.2,14 C1.08954305,14 1,13.9552284 1,13.9 L1,10.1 C1,10.0447715 1.08954305,10 1.2,10 Z M18,11.6153846 C18,13.4846561 16.4846561,15 14.6153846,15 L7.84615385,15 C7.37883602,15 7,14.621164 7,14.1538462 L7,4.84615385 C8.1282051,4.28205128 9.39743587,4 10.8076923,4 C12.9089391,4 15.0384615,6.12783884 15.0384615,8.23076923 C16.7079981,8.4650878 18,9.8893546 18,11.6153846 Z M8,14 L14.5454545,14 C15.9010625,14 17,12.9010625 17,11.5454545 C17,10.3050264 16.0718944,9.25574738 14.8408286,9.08296796 L14.1363636,8.98409667 L14.1363636,8.27272727 C14.1363636,6.69177453 12.4441412,5 10.8636364,5 C9.81175629,5 8.85922746,5.17619715 8,5.52684396 L8,14 Z" })
);
var SoundCloudIcon_default = SoundCloudIcon;
export {
  SoundCloudIcon_default as default
};
//# sourceMappingURL=SoundCloudIcon.js.map
